import { includes } from 'lodash/fp'

import type { ManagedLearnpathPutRequest } from '@/api/generated-api-and-types'

export const APP_LOCALE_PRIMARY = ['de', 'en'] as const
export const APP_LOCALE_FEATURED = [
  'es',
  'fr',
  'it',
  'cs',
  'hu',
  'pl',
  'pt',
  'sk',
  'el',
  'tr',
  'nl',
  'pt-br',
  'ru',
  'sl',
  'zh',
  'ja',
  'ko',
] as const
export const APP_LOCALE_FALLBACK = 'en'
export const APP_LOCALE = [
  ...APP_LOCALE_PRIMARY,
  ...APP_LOCALE_FEATURED,
] as const

// Languages content (learnpaths/courses) can be authored in. `satisfies`
// asserts every entry is accepted by the managed learnpath PUT endpoint's
// `lang` union; a backend removal/rename breaks the build here. When the
// backend adds a language, append it below.
export const CONTENT_LOCALE = [
  'en',
  'de',
  'cs',
  'fr',
  'hu',
  'it',
  'pl',
  'pt',
  'ru',
  'es',
  'nl',
  'sk',
  'el',
  'tr',
  'pt_br',
  'sl',
  'ja',
  'ko',
  'zh',
] as const satisfies readonly NonNullable<ManagedLearnpathPutRequest['lang']>[]

export const isContentLocale = (
  value: string | undefined,
): value is (typeof CONTENT_LOCALE)[number] => includes(value, CONTENT_LOCALE)
